<template>
    <div class="title-list-container">
        <!-- 搜索区域 -->
        <div class="search-bar">
            <el-input v-model="searchForm.title" placeholder="请输入标题" clearable size="large"
                style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
                <template #prefix>
                    <el-icon><Search /></el-icon>
                </template>
            </el-input>

            <el-button type="primary" size="large" @click="handleSearch">
                <el-icon><Search /></el-icon>
                搜索
            </el-button>

            <el-button type="success" size="large" @click="openAddDialog" style="float: right">
                <el-icon><Plus /></el-icon>
                新增标题
            </el-button>

            <el-button type="warning" size="large" @click="openBatchImportDialog"
                style="margin-left: 10px; float: right">
                <el-icon><Upload /></el-icon>
                批量导入
            </el-button>
        </div>

        <!-- 标题列表 -->
        <el-table :data="recordList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
            <el-table-column prop="title" label="标题" width="300" />
            <el-table-column prop="use_num" label="使用次数" width="120" />
            <el-table-column prop="prohibited_words" label="违禁词" width="150" />
            <el-table-column prop="status" label="状态" width="120">
                <template #default="{ row }">
                    <el-tag :type="row.status === 2 ? 'success' : 'warning'">
                        {{ row.status === 2 ? '正常' : '待审核' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="180" />

            <el-table-column label="操作" width="250" fixed="right">
                <template #default="scope">
                    <el-button type="primary" size="small" @click="openEditDialog(scope.row)">
                        <el-icon><Edit /></el-icon>
                        编辑
                    </el-button>
                    <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
                        <el-icon><Delete /></el-icon>
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
            <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
                :total="pagination.total" :page-sizes="[10, 20, 30, 50]"
                layout="total, sizes, prev, pager, next, jumper" @size-change="fetchRecordList"
                @current-change="fetchRecordList" />
        </div>

        <!-- 批量导入弹窗 -->
        <el-dialog v-model="importDialogVisible" title="批量导入标题" width="700px"
            :close-on-click-modal="false" :append-to-body="true"
            class="child-dialog" @close="resetImportDialog">
            <el-tabs v-model="importActiveTab">
                <el-tab-pane label="Excel导入" name="excel">
                    <el-upload class="upload-demo" drag ref="excelUploadRef" action="" :auto-upload="false"
                        :on-change="handleExcelChange" accept=".xlsx,.xls" :limit="1">
                        <el-icon class="el-icon--upload"><UploadFilled /></el-icon>
                        <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
                        <template #tip>
                            <div class="el-upload__tip">请上传Excel文件，支持.xlsx和.xls格式</div>
                            <div style="margin-top: 20px; text-align: center;">
                                <el-button type="text" @click="downloadTemplate">
                                    <el-icon><Download /></el-icon>
                                    下载Excel模板
                                </el-button>
                            </div>
                        </template>
                    </el-upload>
                </el-tab-pane>
                <el-tab-pane label="TXT导入" name="txt">
                    <el-upload class="upload-demo" drag ref="txtUploadRef" action="" :auto-upload="false"
                        :on-change="handleTxtChange" accept=".txt" :limit="1">
                        <el-icon class="el-icon--upload"><UploadFilled /></el-icon>
                        <div class="el-upload__text">将TXT文件拖到此处，或<em>点击上传</em></div>
                        <template #tip>
                            <div class="el-upload__tip">
                                <p>请上传TXT文件，每行一个标题</p>
                                <p>格式：标题内容,一行一个！</p>
                            </div>
                        </template>
                    </el-upload>
                </el-tab-pane>
            </el-tabs>
            <template #footer>
                <el-button @click="importDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitBatchImport">确认导入</el-button>
            </template>
        </el-dialog>

        <!-- 新增/编辑弹窗 -->
        <el-dialog v-model="dialogVisible" :title="dialogTitle" width="700px"
            :close-on-click-modal="false" :append-to-body="true"
            class="child-dialog">
            <el-form ref="recordForm" :model="recordForm" label-width="120px" :rules="formRules">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="recordForm.title" placeholder="请输入标题" size="large" />
                </el-form-item>

                <el-form-item label="违禁词">
                    <el-input v-model="recordForm.prohibited_words" placeholder="请输入违禁词，多个用逗号分隔" size="large" />
                </el-form-item>

                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="recordForm.status">
                        <el-radio :label="1">待审核</el-radio>
                        <el-radio :label="2">正常</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="使用次数">
                    <el-input-number v-model="recordForm.use_num" :min="0" size="large" />
                </el-form-item>
            </el-form>

            <template #footer>
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitRecordForm">确认</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import {
    Search, Plus, Edit, Delete, UploadFilled, Download
} from '@element-plus/icons-vue'
import * as XLSX from 'xlsx'

export default {
    components: {
        Search, Plus, Edit, Delete, UploadFilled, Download
    },
    props: {
        titleId: {
            type: Number,
            required: true
        },
        storeId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            dialogTitle: '新增标题',
            isEditMode: false,
            importDialogVisible: false,
            importActiveTab: 'excel',
            importFile: null,
            importData: [],
            searchForm: {
                title: ''
            },
            recordForm: {
                id: null,
                title: '',
                prohibited_words: '',
                status: 2,
                use_num: 0,
                title_id: this.titleId,
                store_id: this.storeId
            },
            formRules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            },
            recordList: [],
            pagination: {
                page: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    mounted() {
        this.fetchRecordList();
    },
    methods: {
        downloadTemplate() {
            const wb = XLSX.utils.book_new()
            const templateData = [
                { '标题': '示例标题1' },
                { '标题': '示例标题2' }
            ]
            const ws = XLSX.utils.json_to_sheet(templateData)
            ws['!cols'] = [{ wch: 30 }]
            XLSX.utils.book_append_sheet(wb, ws, "标题数据")
            XLSX.writeFile(wb, '标题批量导入模板.xlsx')
        },
        openAddDialog() {
            this.dialogTitle = '新增标题';
            this.isEditMode = false;
            this.recordForm = {
                id: null,
                title: '',
                prohibited_words: '',
                status: 2,
                use_num: 0,
                title_id: this.titleId,
                store_id: this.storeId
            };
            this.dialogVisible = true;
        },
        openEditDialog(row) {
            this.dialogTitle = '编辑标题';
            this.isEditMode = true;
            this.recordForm = {
                id: row.id,
                title: row.title,
                prohibited_words: row.prohibited_words,
                status: row.status,
                use_num: row.use_num,
                title_id: this.titleId,
                store_id: this.storeId
            };
            this.dialogVisible = true;
        },
        resetImportDialog() {
            if (this.$refs.excelUploadRef) {
                this.$refs.excelUploadRef.clearFiles();
            }
            if (this.$refs.txtUploadRef) {
                this.$refs.txtUploadRef.clearFiles();
            }
            this.importFile = null;
            this.importData = [];
            this.importActiveTab = 'excel';
        },
        openBatchImportDialog() {
            this.resetImportDialog();
            this.importDialogVisible = true
            this.importActiveTab = 'excel'
            this.importFile = null
            this.importData = []
        },
        handleExcelChange(file) {
            this.importFile = file
            const reader = new FileReader()
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result)
                const workbook = XLSX.read(data, { type: 'array' })
                const firstSheet = workbook.Sheets[workbook.SheetNames[0]]
                const jsonData = XLSX.utils.sheet_to_json(firstSheet)
                this.importData = jsonData.map(item => ({
                    title: item.title || item['标题'] || '',
                    prohibited_words: item.prohibited_words || item['违禁词'] || '',
                    use_num: item.use_num || item['使用次数'] || 0,
                    status: item.status || item['状态'] || 2
                }))
            }
            reader.readAsArrayBuffer(file.raw)
        },
        handleTxtChange(file) {
            this.importFile = file
            const reader = new FileReader()
            reader.onload = (e) => {
                const content = e.target.result
                const lines = content.split('\n')
                this.importData = lines.map(line => {
                    if (!line.trim()) return null
                    const parts = line.split('|').map(p => p.trim())
                    return {
                        title: parts[0] || '',
                        prohibited_words: parts[1] || '',
                        use_num: parseInt(parts[2]) || 0,
                        status: parseInt(parts[3]) || 2
                    }
                }).filter(item => item && item.title)
            }
            reader.readAsText(file.raw)
        },
        async submitBatchImport() {
            if (this.importData.length === 0) {
                this.$message.warning('没有可导入的数据')
                return
            }
            try {
                const { data } = await axios.post(
                    `${config.BASE_URL}/shop/api/title_create_record.php`,
                    {
                        action: 'batch_import',
                        store_id: this.storeId,
                        title_id: this.titleId,
                        batch: this.importData
                    }
                )
                if (data.success) {
                    this.$message.success(`成功导入 ${data.imported_count} 条记录`)
                    this.resetImportDialog();
                    this.importDialogVisible = false
                    this.fetchRecordList()
                } else {
                    this.$message.error(data.error || '导入失败')
                }
            } catch (error) {
                this.$message.error('导入失败: ' + (error.response?.data?.error || error.message))
                console.error('导入错误:', error)
            }
        },
        submitRecordForm() {
            this.$refs.recordForm.validate(async (valid) => {
                if (valid) {
                    try {
                        const action = this.isEditMode ? 'update' : 'add';
                        const { data } = await axios.post(
                            `${config.BASE_URL}/shop/api/title_create_record.php`,
                            {
                                action,
                                ...this.recordForm
                            }
                        );
                        if (data.success) {
                            this.$message.success(this.isEditMode ? '更新成功' : '添加成功');
                            this.dialogVisible = false;
                            this.fetchRecordList();
                        } else {
                            this.$message.error(data.error || '操作失败');
                        }
                    } catch (error) {
                        const errorMsg = error.response?.data?.error || error.message || '操作失败';
                        this.$message.error(`操作失败: ${errorMsg}`);
                        console.error('表单提交错误:', error);
                    }
                }
            });
        },
        async fetchRecordList() {
            this.loading = true;
            try {
                const params = {
                    action: this.searchForm.title ? 'search' : 'list',
                    store_id: this.storeId,
                    title_id: this.titleId,
                    page: this.pagination.page,
                    page_size: this.pagination.pageSize
                };
                if (this.searchForm.title) {
                    params.title = this.searchForm.title;
                }
                const { data } = await axios.post(
                    `${config.BASE_URL}/shop/api/title_create_record.php`,
                    params
                );
                if (data.data) {
                    this.recordList = data.data;
                    this.pagination.total = data.pagination?.total || data.data.length;
                }
            } catch (error) {
                this.$message.error('获取标题列表失败');
                console.error('获取标题列表错误:', error);
            } finally {
                this.loading = false;
            }
        },
        handleSearch() {
            this.pagination.page = 1;
            this.fetchRecordList();
        },
        async handleDelete(id) {
            this.$confirm('确定要删除该标题吗？', '警告', {
                confirmButtonText: '确认删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const { data } = await axios.post(
                        `${config.BASE_URL}/shop/api/title_create_record.php`,
                        {
                            action: 'delete',
                            id: id,
                            store_id: this.storeId
                        }
                    );
                    if (data.success) {
                        this.$message.success('删除成功');
                        this.fetchRecordList();
                    } else {
                        this.$message.error(data.error || '删除失败');
                    }
                } catch (error) {
                    this.$message.error('删除失败');
                    console.error('删除错误:', error);
                }
            }).catch(() => { });
        }
    }
}
</script>

<style scoped>
.title-list-container {
    padding: 20px;
    background: transparent !important;
    color: #e0e0e0;
}

.search-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 20px;
    padding: 16px;
    background: rgba(18, 14, 33, 0.4) !important;  /* 添加 !important */
    backdrop-filter: blur(10px);
    border-radius: 12px;
    border: 1px solid rgba(157, 78, 221, 0.2);
}

.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

:deep(.el-table) {
    background-color: transparent !important;
}

:deep(.el-table__body-wrapper) {
    background-color: transparent !important;
}

:deep(.el-pagination) {
    --el-pagination-bg-color: transparent;
}

:deep(.el-pagination .btn-prev),
:deep(.el-pagination .btn-next),
:deep(.el-pagination .el-pager li) {
    background: rgba(157, 78, 221, 0.1) !important;
    border: 1px solid rgba(157, 78, 221, 0.3) !important;
    color: #a0a0c0 !important;
}

:deep(.el-pagination .btn-prev:hover),
:deep(.el-pagination .btn-next:hover),
:deep(.el-pagination .el-pager li:hover) {
    background: rgba(157, 78, 221, 0.2) !important;
    color: #c084fc !important;
}

:deep(.el-pagination .el-pager li.active) {
    background: linear-gradient(135deg, #6546b4, #9d4edd) !important;
    color: #fff !important;
}

:deep(.el-pagination__total),
:deep(.el-pagination__jump) {
    color: #a0a0c0 !important;
}
</style>